import React from 'react';
import {BrowserRouter as Router, Route, Routes, useNavigate, useLocation} from 'react-router-dom';
import LoginPage from './components/Login/LoginPage';
import Dashboard from './components/Dashboard/Dashboard';
import ManagementDashboard from './components/Dashboard/ManagementDashboard';
import ExecutiveReports from './components/Dashboard/ExecutiveReports';
import TrainingAnalytics from './components/Dashboard/TrainingAnalytics'
import NavbarComponent from "./components/Navbar/NavbarComponent";
import Footer from "./components/Footer/Footer";
import MainForm from "./components/MultiStepForm/MainForm/MainForm";
import {AuthProvider, useAuth} from "./components/AuthContext/AuthContext";
import StaffList from "./components/Staff/StaffList";
import DangerZone from "./components/DangerZone/DangerZone";
import UserRegistrationPage from "./components/Users/UserRegistrationPage";
import NotAuthorized from "./components/NotAuthorized/NotAuthorized";
import {ProtectedRoute} from "./components/ProtectedRoutes/ProtectedRoute";
import UserList from "./components/Users/UserList";
import UserRegistrationSuccess from "./components/Users/UserRegistrationSuccess";
import UserDetail from "./components/Users/UserDetail";
import SupervisorManagement from "./components/Supervisor/SupervisorManagement"
import DutyStationManagement from "./components/DutyStation/DutyStationManagement"
// import StaffCheckout from "./components/Staff/StaffListComponent/StaffListComponent";
import PasswordReset from "./components/Users/PasswordReset"
import Asset from "./components/Assets/Assets"
import RoleManagement from "./components/Roles/RoleManagement"
import {NotificationProvider} from "./components/SharedComponents/Notifications/NotificationContext";
import Notification from "./components/SharedComponents/Notifications/Notification"

import StaffCheckOutProcess from "./components/CheckOutProcess/CheckoutProcess";
import ICTCheckoutDashboard from './components/CheckOutProcess/ICTCheckoutDashboard';
import SecurityCheckoutDashboard from './components/CheckOutProcess/SecurityCheckoutDashboard';
import HRCheckoutDashboard from './components/CheckOutProcess/HRCheckoutDashboard';
import CompletedCheckoutsList from './components/CheckOutProcess/Completedcheckoutslist';
import Breadcrumbs from './components/Breadcrumbs/Breadcrumbs'
import './i18n/i18n';

// Layout component to handle the structure of every page
const Layout = ({ children }) => {
    const location = useLocation();
    const showBreadcrumbs = location.pathname !== '/' && location.pathname !== '/login';

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh', // This ensures the container takes up at least the full viewport height
        }}>
            <NavbarComponent />
            {/* Notification stays outside the main content area as it's global */}
            <Notification />

            {/* Main content wrapper that will push the footer down */}
            <main style={{
                flex: '1 0 auto', // This is crucial - it tells the main content to grow and take available space
                display: 'flex',
                flexDirection: 'column'
            }}>
                {showBreadcrumbs && <Breadcrumbs />}
                {children}
            </main>

            <Footer />
        </div>
    );
};

function App() {
    return (
        <AuthProvider>
            <NotificationProvider>
                <Router>
                    <Layout>
                        <Routes>
                            {/* Login routes */}
                            <Route path="/" element={<LoginPage/>}/>
                            <Route path="/login" element={<LoginPage/>}/>
                            <Route path="/reset-password" element={<PasswordReset/>}/>
                            <Route path="/user-registration-page" element={<UserRegistrationPage />}/>

                            {/*<Route path="/user-registration-page" element={*/}
                            {/*    <ProtectedRoute allowedRoles={['ICT', 'HR', 'MANAGEMENT']}>*/}
                            {/*        <UserRegistrationPage/>*/}
                            {/*    </ProtectedRoute>*/}
                            {/*}/>*/}


                            {/* MAIN DASHBOARD - All users land here after login */}
                            <Route path="/dashboard" element={
                                <ProtectedRoute allowedRoles={['ICT','STAFF', 'SECURITY', 'HR', 'MANAGEMENT']}>
                                    <Dashboard/>
                                </ProtectedRoute>
                            }/>

                            {/* MANAGEMENT DASHBOARD - Accessible via card/link from main dashboard */}
                            <Route path="/management-analytics" element={
                                <ProtectedRoute requiredRoles={['MANAGEMENT', 'ICT', 'HR']}>
                                    <ManagementDashboard />
                                </ProtectedRoute>
                            } />

                            <Route path="/executive-reports" element={
                                <ProtectedRoute requiredRoles={['MANAGEMENT', 'ICT', 'HR']}>
                                    <ExecutiveReports />
                                </ProtectedRoute>
                            } />

                            <Route path="/training-analytics" element={
                                <ProtectedRoute requiredRoles={['MANAGEMENT', 'HR']}>
                                    <TrainingAnalytics />
                                </ProtectedRoute>

                            } />

                            <Route path="/management-dashboard" element={
                                <ProtectedRoute requiredRoles={['MANAGEMENT']}>
                                    <ManagementDashboard />
                                </ProtectedRoute>
                            } />

                            {/* Management Dashboard with specific tabs */}
                            <Route path="/management-analytics/overview" element={
                                <ProtectedRoute requiredRoles={['MANAGEMENT', 'ICT', 'HR']}>
                                    <ManagementDashboard activeTab="overview" />
                                </ProtectedRoute>
                            }/>

                            <Route path="/management-analytics/staff" element={
                                <ProtectedRoute requiredRoles={['MANAGEMENT', 'ICT', 'HR']}>
                                    <ManagementDashboard activeTab="staff" />
                                </ProtectedRoute>
                            }/>

                            <Route path="/management-analytics/assets" element={
                                <ProtectedRoute requiredRoles={['MANAGEMENT', 'ICT', 'HR']}>
                                    <ManagementDashboard activeTab="assets" />
                                </ProtectedRoute>
                            }/>

                            {/* Specific analytics routes with role restrictions */}
                            <Route path="/staff-analytics" element={
                                <ProtectedRoute requiredRoles={['HR', 'MANAGEMENT']}>
                                    <ManagementDashboard activeTab="staff" />
                                </ProtectedRoute>
                            } />

                            <Route path="/asset-analytics" element={
                                <ProtectedRoute requiredRoles={['ICT', 'MANAGEMENT']}>
                                    <ManagementDashboard activeTab="assets" />
                                </ProtectedRoute>
                            } />

                            {/* Staff management routes */}
                            <Route path="/staff-checkin" element={
                                <ProtectedRoute allowedRoles={['ICT', 'STAFF', 'SECURITY', 'HR', 'MANAGEMENT']}>
                                    <MainForm/>
                                </ProtectedRoute>
                            }/>

                            <Route path="/staff-list" element={
                                <ProtectedRoute allowedRoles={['ICT', 'STAFF', 'SECURITY', 'HR', 'MANAGEMENT']}>
                                    <StaffList/>
                                </ProtectedRoute>
                            }/>

                            {/* User management routes */}

                            <Route path="/users" element={
                                <ProtectedRoute allowedRoles={['ICT']}>
                                    <UserList/>
                                </ProtectedRoute>
                            }/>

                            <Route path="/user-detail/:userId" element={
                                <ProtectedRoute allowedRoles={['ICT']}>
                                    <UserDetail/>
                                </ProtectedRoute>
                            }/>

                            {/* System management routes */}
                            <Route path="/role-management" element={
                                <ProtectedRoute allowedRoles={['ICT', 'MANAGEMENT']}>
                                    <RoleManagement/>
                                </ProtectedRoute>
                            }/>

                            <Route path="/danger-zone" element={
                                <ProtectedRoute allowedRoles={['ICT', 'MANAGEMENT']}>
                                    <DangerZone/>
                                </ProtectedRoute>
                            }/>

                            {/* Checkout process routes */}
                            <Route path="/staff-checkout" element={
                                <ProtectedRoute allowedRoles={['ICT', 'STAFF', 'SECURITY', 'HR', 'MANAGEMENT']}>
                                    <StaffCheckOutProcess/>
                                </ProtectedRoute>
                            }/>

                            {/* ICT specific routes */}
                            <Route path="/ict-checkout-list" element={
                                <ProtectedRoute allowedRoles={['ICT']}>
                                    <ICTCheckoutDashboard/>
                                </ProtectedRoute>
                            }/>

                            <Route path="/ict-asset" element={
                                <ProtectedRoute allowedRoles={['ICT', 'SECURITY']}>
                                    <Asset/>
                                </ProtectedRoute>
                            }/>

                            {/* HR specific routes */}
                            <Route path="/hr-checkout-list" element={
                                <ProtectedRoute allowedRoles={['HR']}>
                                    <HRCheckoutDashboard/>
                                </ProtectedRoute>
                            }/>

                            <Route path="/completed-checkouts" element={
                                <ProtectedRoute allowedRoles={['HR', 'MANAGEMENT']}>
                                    <CompletedCheckoutsList/>
                                </ProtectedRoute>
                            }/>

                            <Route path="/supervisor-management" element={
                                <ProtectedRoute allowedRoles={['ICT', 'HR', 'MANAGEMENT']}>
                                    <SupervisorManagement/>
                                </ProtectedRoute>
                            }/>

                            <Route path="/duty-station-management" element={
                                <ProtectedRoute allowedRoles={['ICT', 'HR', 'MANAGEMENT']}>
                                    <DutyStationManagement/>
                                </ProtectedRoute>
                            }/>

                            {/* Security specific routes */}
                            <Route path="/security-checkout-list" element={
                                <ProtectedRoute allowedRoles={['SECURITY']}>
                                    <SecurityCheckoutDashboard/>
                                </ProtectedRoute>
                            }/>

                            {/* Public/utility routes */}
                            <Route path="/not-authorized" element={<NotAuthorized/>}/>
                            <Route path="/registration-success" element={<UserRegistrationSuccess/>}/>
                        </Routes>
                    </Layout>
                </Router>
            </NotificationProvider>
        </AuthProvider>
    );
}

export default App;